import React from "react";
import axios from "axios";
import Error from "next/error";
import Page from "../components/page";
import DataFetcher from "../util/dataFetcher";
import { SiteChrome, SiteData } from '../components/chrome/layout';

import { PriceTagString, convertNumber } from "./../components/chrome/elements/utils";

export default class extends Page {
    static async getInitialProps({ req, query, res }) {
        const props = await super.getInitialProps({ req, res });
        props.pageType = "mission";
        props.path = `/mission/${query.slug}`;
        props.slug = query.slug;

        props.data = await DataFetcher.getMission(props.slug, { req });
        return props;
    }

    // PledgeHandler
    constructor(props) {
        super(props);
        this.state = {
            hasPledged: props.data.hasPledged,
            refresh: true
        }
    }

    handlePledgeSubmit = () => {

        const { hasPledged, refresh } = this.state;

        this.setState({
            hasPledged: !hasPledged
        });

        !hasPledged ? axios({
            method: "post",
            url: '/api/v1.1/mission/pledge',
            data: {
                missionId: 1,
                _csrf: this.props.store._csrf
            }
        }).then(
            this.setState({
                refresh: !refresh
            })
        ).catch() : axios({
            method: "post",
            url: '/api/v1.1/mission/unpledge',
            data: {
                missionId: 1,
                _csrf: this.props.store._csrf
            }
        }).then(
            this.setState({
                refresh: !refresh
            })
        ).catch()


    }

    render() {
        // Error 404 page for slug mismatch
        if (this.props.data.error) {
            return <Error statusCode={404} />;
        }

        const { session } = this.props;
        const store = { ... this.props.store };
        const { name, slug, description, image, pledgeText, supporterCount, updatedAt } = this.props.data;

        return (
            <SiteData store={store}>
                <SiteChrome session={session}>
                    <section className="container">
                        <div className="row">
                            <div className="col-12 mission-header">
                                <h2 className="heading">{name}</h2>
                            </div>
                        </div>

                        {/* For Mobile only */}
                        <div className="col-12 hero-image-for-mobile">
                            <img className="mission-hero-image" src={image} style={{ marginBottom: '2rem' }} />
                        </div>


                        <div className="row mission-main-content-wrapper">
                            <main className="col-md-7 mission-main-content">
                                {/* Hiding on the Mobile */}
                                <img className="mission-hero-image image-for-desktop" src={image} style={{ marginBottom: '2rem' }} />

                                <div dangerouslySetInnerHTML={{__html: description}} />

                            </main>

                            <aside className="col-md-5 mission-sidebar">
                                <div className="mission-aside-pledge">
                                    <p className="mission-aside-pledge-sub-heading"><strong>Your Mission</strong></p>
                                    <p>
                                        {pledgeText}
                                    </p>

                                    <button style={{ background: this.state.hasPledged ? "#cecece" : "#ff5050" }} className="btn w-100 p-10 mission-pledge-button" onClick={this.handlePledgeSubmit}> {this.state.hasPledged ? 'Pledged' : 'Pledge Your Support'}</button>
                                </div>

                                <div className="mission-aside-total-supporters">
                                    <p className="mission-aside-pledge-sub-heading"><strong>Total Supporters</strong></p>
                                    <p className="total-supported-amount">{convertNumber(supporterCount)}</p>
                                    <p>
                                        Join the mission and help change the world into a better one. Act now.
              </p>
                                </div>
                            </aside>
                        </div>
                        <style jsx global>{`
          .mission-header{
            display:flex;
            justify-content:center;
            margin:35px auto;
          }

          .mission-header .heading{
            margin-bottom:0;
          }

          .mission-hero-image{
            height:402px;
            width:100%;
            min-height:100%;
            min-width:100%;
          }

          .hero-image-for-mobile{
              display:none;
          }
          .mission-aside-pledge,.mission-aside-total-supporters{
             border:1px solid #999999;
             padding:1rem;
             
          }
          .mission-aside-pledge{ 
            margin-bottom:26px;
            padding-bottom:1.5rem;
          }

         .mission-aside-pledge-sub-heading{
           font-size:20px;
         }
          .mission-aside-total-supporters p{
            margin:0;
          }

          .mission-pledge-button{
            color:#fff;
          }

           .mission-pledge-button:hover{
               cursor:pointer;
           }

          .total-supported-amount{
            font-size:30px;
            font-weight:800;
            margin:5px 0 !important;
          }

          .mission-article{
            margin-top:1.5rem;
          }

          .mission-article div{
            text-align:justify;
          }

          @media (max-width: 767px) {
            .mission-main-content-wrapper{
                display:flex;
                flex-direction:column;
            }
            .mission-sidebar{
                order:-1;
            }
            .mission-aside-total-supporters{
                margin-bottom:1rem;
            }
            .image-for-desktop{
                display:none;
            }
            .hero-image-for-mobile{
                display:block;
            }
          }
        `}</style>
                    </section>
                </SiteChrome>
            </SiteData>
        )
    }
}
